// extracted by css-extract-rspack-plugin
export default {"title":"_ed9e4ca6"};